"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _uuid = _interopRequireDefault(require("uuid"));
var _constants = require("./constants");
var _style = _interopRequireDefault(require("./style.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var classKey = 'toast-box';
var TOAST_NAME = _lodash.default.get(_style.default, classKey, classKey);
var Message = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Message, _PureComponent);
  var _super = _createSuper(Message);
  function Message(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Message);
    _this = _super.call(this, props);
    _this.state = {
      show: false
    };
    _this.hideMessage = _this.hideMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.clearMessage = _this.clearMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.showMessage = _this.showMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderIcon = _this.renderIcon.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(Message, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timeOut = setTimeout(this.showMessage, _constants.ANIMATION_DURATION);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeOut);
    }
  }, {
    key: "clearMessage",
    value: function clearMessage() {
      this.props.onClearMessage(this.props.data);
    }
  }, {
    key: "showMessage",
    value: function showMessage() {
      this.setState({
        show: true
      });
      if (this.props.data.autoDismiss) {
        this.timeOut = setTimeout(this.hideMessage, this.props.data.duration);
      }
    }
  }, {
    key: "hideMessage",
    value: function hideMessage() {
      this.setState({
        show: false
      });
      this.timeOut = setTimeout(this.clearMessage, _constants.ANIMATION_DURATION);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var icon = '';
      switch (this.props.data.type) {
        case 'warning':
          icon = /*#__PURE__*/_react.default.createElement("i", {
            className: "fas fa-triangle-exclamation toast-icon warning-icon"
          });
          break;
        case 'info':
          icon = /*#__PURE__*/_react.default.createElement("i", {
            className: "fas fa-circle-info toast-icon info-icon"
          });
          break;
        case 'success':
          icon = /*#__PURE__*/_react.default.createElement("i", {
            className: "fas fa-circle-check toast-icon success-icon"
          });
          break;
        case 'error':
          icon = /*#__PURE__*/_react.default.createElement("i", {
            className: "fas fa-octagon-xmark toast-icon error-icon"
          });
          break;
        default:
          icon = /*#__PURE__*/_react.default.createElement("i", {
            className: "fas fa-triangle-exclamation toast-icon warning-icon"
          });
      }
      return icon;
    }
  }, {
    key: "renderStatic",
    value: function renderStatic() {
      if (!this.state.show) {
        return null;
      }
      var _this$props$data = this.props.data,
        text = _this$props$data.text,
        staticClose = _this$props$data.staticClose,
        type = _this$props$data.type,
        buttonActions = _this$props$data.buttonActions;
      var toastShow = this.state.show ? "".concat(TOAST_NAME, " animated fade in") : "".concat(TOAST_NAME, " animated fade");
      var style = {
        transition: '300ms',
        opacity: this.state.show ? 1 : 0
      };
      // Split a text into sentences
      // and show in new line
      var textArray = _lodash.default.isString(text) && text.trim().split('. ');
      var button = staticClose ? /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.hideMessage,
        className: "close"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fal fa-times fa-lg"
      })) : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: toastShow,
        style: style
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "toast-".concat(type || 'warning', " toast")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, /*#__PURE__*/_react.default.createElement("span", null, this.renderIcon()), /*#__PURE__*/_react.default.createElement("div", {
        className: "main-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "text-content"
      }, _lodash.default.isFunction(text) ? text() : textArray.map(function (content, index) {
        return /*#__PURE__*/_react.default.createElement("p", null, index === textArray.length - 1 ? content : "".concat(content, "."));
      })), buttonActions && buttonActions.length && /*#__PURE__*/_react.default.createElement("div", {
        className: "action"
      }, buttonActions.map(function (btn) {
        return btn.customTag || /*#__PURE__*/_react.default.createElement("span", {
          key: _uuid.default.v4(),
          role: "presentation",
          className: "action__btn",
          onClick: btn.onClick
        }, btn.title);
      }))), button)));
    }
  }, {
    key: "renderMessage",
    value: function renderMessage() {
      var messageTypeClass = this.props.data.type;
      var showClass = this.state.show ? 'in' : 'hidden';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "message animated fade ".concat(messageTypeClass, " ").concat(showClass)
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          marginRight: '12px'
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-triangle-exclamation"
      })), this.props.data.text, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.hideMessage,
        className: "close"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fas fa-times"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.static ? this.renderStatic() : this.renderMessage();
    }
  }]);
  return Message;
}(_react.PureComponent);
Message.propTypes = {
  onClearMessage: _propTypes.default.func.isRequired,
  data: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    text: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.func]),
    type: _propTypes.default.oneOf(['success', 'error', 'info', 'warning']),
    duration: _propTypes.default.number,
    staticClose: _propTypes.default.bool,
    autoDismiss: _propTypes.default.bool,
    buttonActions: _propTypes.default.arrayOf(_propTypes.default.shape({
      customTag: _propTypes.default.node,
      onClick: _propTypes.default.func,
      title: _propTypes.default.string
    }))
  }).isRequired,
  static: _propTypes.default.bool.isRequired
};
var _default = Message;
exports.default = _default;